/* src/app/main/pages/services/verticals/verticals-content/verticals-content.component.css */
.main-div {
  border-bottom: 10px solid #F2F2F2;
}
.main-div .number {
  color: rgb(227 100 10 / 0.77);
  padding-right: 6px;
}
.main-div .bg-img-top::after {
  content: "";
  position: absolute;
  background-image: url(/assets/images/our-services/bg-triangle.png);
  right: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 300px;
  top: 0px;
}
.main-div .bg-img-bottom::after {
  content: "";
  position: absolute;
  background-image: url(/assets/images/our-services/services-bg-triangle.png);
  right: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 300px;
  bottom: -60px;
}
.arrow-overlap-img:before {
  content: "";
  position: absolute;
  background-image: url(/assets/images/our-services/overlap-arrow-1.png);
  left: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 240px;
  bottom: 0px;
}
.arrow-overlap-img-top:before {
  content: "";
  position: absolute;
  background-image: url(/assets/images/our-services/arrow-overlap-top.png);
  left: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 240px;
  top: 0px;
}
@media (min-width: 1680px) {
  .main-div h2 {
    margin-bottom: 25px !important;
  }
  .main-div p {
    font-size: 21px;
  }
}
@media (min-width: 1600px) and (max-width: 1679px) {
  .main-div p {
    font-size: 21px;
  }
}
@media (device-width: 1280px) {
  .main-div .bg-img-bottom::after {
    bottom: -70px;
  }
}
@media (max-width: 1024px) {
  .main-div p {
    margin-bottom: 50px;
  }
}
/*# sourceMappingURL=verticals-content.component.css.map */
